import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PhoneInput from 'react-phone-number-input';
import {updateUserArticlesManager} from '../../../redux/actions/userActions';

class PermistionsUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            phone: '',
            user: null,
            not_user: false,
            active: 'email',
        }
    }
    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value })
    };
    handlePhone = (data) => {
        this.setState({ phone: data })
    }
    handleActionSend = () => {
        var users = this.props.users;
        const {email, phone, active} = this.state;
        users = users.filter((user) => {
            if (active === 'phone') {
                return user.phone === phone;
            } else {
                return user.email === email;
            }
        })
        users.length > 0 ?
          this.setState({user: users[0]})
        : this.setState({not_user: true})
    }
    activeShopManager = () => {
        const userId = this.state.user.userId;
        this.props.updateUserArticlesManager(userId);
    }
    xoa_dau = (alias)  => {
        var str = alias;
        str = str.toLowerCase();
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g,"a"); 
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g,"e"); 
        str = str.replace(/ì|í|ị|ỉ|ĩ/g,"i"); 
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g,"o"); 
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g,"u"); 
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g,"y"); 
        str = str.replace(/đ/g,"d");
        str = str.replace(/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'|"|&|#|\[|\]|~|\$|_|`|-|{|}|\||\\/g," ");
        str = str.replace(/ + /g," ");
        str = str.trim(); 
        return str;
    }
    handleActive = (e) => {
        this.setState({
            active: e,
        })
    }
    render() {
        const {email, phone, user, not_user, active} = this.state;
        const {permistions: {loading}} = this.props;
        console.log(user)
        return (
            <div className="box-add">
                <div className="box-add-find-user">
                    <div className="box-add-find-user--find">
                        <div className={`icon email ${active === 'email' ? 'active' : ''}`} onClick={() => this.handleActive('email')}><i className="fal fa-envelope" /></div>
                        <div className={`icon phone ${active === 'phone' ? 'active' : ''}`} onClick={() => this.handleActive('phone')}><i className="fal fa-phone-alt" /></div>
                        <div className="icon id">ID</div>
                        <div className="form-control">
                            {active === 'email' &&
                            <input 
                            type="text" 
                            name="email"
                            className="input-control fullWidth"
                            value={email}
                            placeholder="Nhập email"
                            onChange={this.handleChange}
                            autoFocus
                            />
                            }
                            {active === 'phone' &&
                            <PhoneInput
                                country="VN"
                                displayInitialValueAsLocalNumber
                                placeholder="Nhập số điện thoại"
                                value={phone}
                                onChange={this.handlePhone}
                            />
                            }
                        </div>
                        <button className="btn btn-icon" onClick={this.handleActionSend}><i className="fal fa-search" /></button>
                        {(!not_user && user) &&
                        (<div className="check-action mt-10">
                            <p>Vui lòng kiểm tra thông tin trước khi thực hiện hành động này.</p>
                            {loading ?
                            <p className="mb-0">Đang gửi...</p>
                            :
                            <p className="text-link-dark mb-0" onClick={this.activeShopManager}>Chỉ định Quản lý Trang</p>
                            }
                        </div>)
                        }
                    </div>
                    {not_user ?
                    <div className="box-add-find-user--info">
                         <p>Không tìm thấy người dùng này.</p>
                    </div>
                    : user &&
                    <div className="box-add-find-user--info">
                        <p className="name">{user.fullname}</p>
                        <p className="email">{user.email ? user.email : 'Không xác định'}</p>
                        <p className="phone">{user.phone ? user.phone : 'Không xác định'}</p>
                        <p className="gender">{user.gender === 1 ? 'Nữ' : user.gender === 2 ? 'Khác' : 'Nam'}</p>
                    </div>
                    }
                    {!not_user && user &&
                    <div className="box-add-find-user--result member">
                        <div className="box-card">
                            <div className="content">
                                <p className="name">{this.xoa_dau(user.fullname)}</p>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        )
    }
}

PermistionsUser.propTypes = {
    updateUserArticlesManager: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    permistions: state.permistions,
})

export default connect(mapStateToProps, { updateUserArticlesManager })(PermistionsUser);
